import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import TemplatesPanel from './CreateTemplateDialog/TemplatePanel.js'

import SelectTemplateDialog from "../SelectTemplateDialog.js"

/**
 * <CreateTemplateDialog onCreateTemplate = {template} onCancel = {} />
 */

class CreateTemplateDialog extends Component {

	state = {
		name: "",
		templates: [],
		dialog: undefined,
	}

	isReadyToCreate() {
		return this.state.name !== ""
	}

	render() {
		return this.state.dialog ?
			this.state.dialog
		:
			<Dialog
				open = {true}
				scroll = "body"
			>
				<DialogTitle>
					Создать шаблон
				</DialogTitle>
				<DialogContent style = {{display: "flex", flexDirection: "column"}}>
					<TemplatesPanel 
						templates = {this.state.templates}
						onSelectTemplateClick = {(template) => {
							this.setState({
								dialog: <SelectTemplateDialog 
									onSelectTemplate = {(template) =>{
										this.setState({
											templates: [...this.state.templates, template],
											dialog: undefined,
										})
									}}
									onCancel = {() => {
										this.setState({dialog: undefined})
									}}
								/>
							})
						}}
						onRemoveTemplateClick = {(template) => {
							this.setState({
								templates: this.state.templates.filter(t => t.id != template.id)
							})
						}}
					/>
					<TextField
						value = {this.state.name}
						label = "Название шаблона"
						margin = "normal"
						onChange = {e => {
							this.setState({
								name: e.target.value
							})
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						disabled = {!this.isReadyToCreate()}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onCreateTemplate === "function") {
								this.props.onCreateTemplate({
									name: this.state.name,
								}, this.state.templates)
							}
						}}
					>Создать</Button>
					<Button
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onCancel === "function") {
								this.props.onCancel()
							}
						}}
					>Отмена</Button>
				</DialogActions>
			</Dialog>

	}

}

export default CreateTemplateDialog
